




















































import {Vue, Component, Prop} from 'vue-property-decorator'
import PercentageProgress from '@/components/misc/PercentageProgress.vue'

@Component({
  components: {PercentageProgress},
})
export default class InvocationNetworkCard extends Vue {
  @Prop({type: String, required: true}) title!: string
  @Prop({type: String, required: true}) todayValue!: string
  @Prop({type: String, required: true}) weekValue!: string
  @Prop({type: String, required: true}) monthValue!: string
  @Prop({type: String, required: true}) allTimeValue!: string
  @Prop({type: Number, required: true}) todayPercentage!: number
  @Prop({type: Number, required: true}) weekPercentage!: number
  @Prop({type: Number, required: true}) monthPercentage!: number
  @Prop({type: Number, required: true}) allTimePercentage!: number
}
